import { defaultEmojiDataResolver } from 'frimousse';

import { isEmoji } from './isEmoji';

import type { EmojiDataResolver } from 'frimousse';

/**
 * Emoji a Natter never offers or shows as a reaction: rude or sexual in common use (product list,
 * HNS-384). Written bare; `isBlockedEmoji` strips skin tones and U+FE0F before looking one up, so
 * 🖕🏽 is blocked with 🖕.
 */
export const BLOCKED_EMOJI: ReadonlySet<string> = new Set(['🖕', '🍆', '🍑', '💦', '🤬', '💩', '👅', '💋', '🍌', '🔫']);

/** Skin-tone modifiers and the emoji presentation selector, as `isEmoji` names them. */
const MODIFIERS = /\p{Emoji_Modifier}|\uFE0F/gu;

export const isBlockedEmoji = (emoji: string): boolean => BLOCKED_EMOJI.has(emoji.replace(MODIFIERS, ''));

/**
 * A single emoji that may be shown as a reaction. The receive-side gate for room and chat reactions:
 * the picker hides blocked emoji, but a reaction is a client-published string, so one pasted or sent
 * by a modified client is dropped here too.
 */
export const isAllowedReaction = (value: unknown): value is string => isEmoji(value) && !isBlockedEmoji(value);

/**
 * The pickers' emoji data: Emojibase's, less the blocked emoji. The default resolver still applies
 * the `emojiVersion` cap it is handed (`EMOJI_PICKER_VERSION`, set by `EmojiPickerPanel`), so every
 * listed emoji stays inside the pinned Noto artwork.
 */
export const resolveAllowedEmojiData: EmojiDataResolver = async (locale, options) => {
  const data = await defaultEmojiDataResolver(locale, options);

  return { ...data, emojis: data.emojis.filter(({ emoji }) => !isBlockedEmoji(emoji)) };
};
